import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { WizardWithData } from '../wizard/wizard-data';
export default function WizardApp() {
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Wizard" }, void 0) }, void 0),
            _jsx(WizardWithData, {}, void 0)] }, void 0));
}
//# sourceMappingURL=WizardApp.js.map